import { MapPin, Clock, Navigation } from "lucide-react";

function getOpenState() {
  const now = new Date();
  const mins = now.getHours() * 60 + now.getMinutes();
  return mins >= 12 * 60 && mins < 22 * 60 + 30;
}

export default function Visit({ info }) {
  const isOpen = getOpenState();
  return (
    <section
      id="contact"
      data-testid="visit-section"
      className="py-20 px-6 max-w-7xl mx-auto border-t border-[#1E313D]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div data-reveal>
          <span className="text-xs uppercase tracking-widest text-[#D4AF37] font-semibold">
            Plan Your Dine-In
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#F3EAD8] mt-2 mb-4">
            Visit Al-Hameediya in Nagpur
          </h2>
          <p className="text-sm text-[#A8B8C0] leading-relaxed mb-6">
            {info?.dinein_note ||
              "We welcome families, friend groups, and food enthusiasts across Nagpur, Maharashtra. Come hungry for an occasion feast."}
          </p>

          <div className="space-y-4 mb-8">
            <div
              data-testid="visit-location-card"
              className="flex items-start gap-4 p-4 bg-[#111D25] rounded-lg border border-[#1E313D]"
            >
              <div className="w-8 h-8 rounded bg-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] shrink-0">
                <MapPin size={16} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-[#D4AF37] font-semibold">
                  Service Area & Location
                </p>
                <p className="text-sm font-medium text-[#F3EAD8]">
                  {info?.address_line || "Nagpur, Maharashtra · Dine-In Restaurant"}
                </p>
                <a
                  href={info?.map_link || "https://maps.google.com/?q=21.107498,79.103401"}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="get-directions-link"
                  className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-semibold text-[#F7D774] hover:text-[#D4AF37] transition-colors"
                >
                  <Navigation size={12} />
                  Get Directions
                </a>
              </div>
            </div>

            <div
              data-testid="visit-hours-card"
              className="flex items-start gap-4 p-4 bg-[#111D25] rounded-lg border border-[#1E313D]"
            >
              <div className="w-8 h-8 rounded bg-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] shrink-0">
                <Clock size={16} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-[#D4AF37] font-semibold">
                  Service Hours
                </p>
                <p className="text-sm font-medium text-[#F3EAD8]">
                  {info?.hours || "Open Daily · 12:00 PM – 10:30 PM"}
                </p>
                <p
                  data-testid="open-now-badge"
                  className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-semibold"
                >
                  <span
                    className={`w-2 h-2 rounded-full ${
                      isOpen ? "bg-green-500 animate-pulse" : "bg-red-500"
                    }`}
                  ></span>
                  <span className={isOpen ? "text-green-400" : "text-red-400"}>
                    {isOpen ? "Open Now · Closes 10:30 PM" : "Closed · Opens 12:00 PM"}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 bg-[#0B1319] border border-[#D4AF37]/30 rounded text-xs text-[#A8B8C0]">
            <span className="text-[#F7D774] font-semibold">
              Informational Menu Notice:
            </span>{" "}
            Complete pricing and dish availability are listed on this page for
            your dining convenience. Table booking will be enabled in upcoming
            updates.
          </div>
        </div>

        <div
          data-testid="visit-map"
          data-reveal
          style={{ transitionDelay: "0.15s" }}
          className="h-80 sm:h-96 rounded-xl border border-[#1E313D] relative overflow-hidden"
        >
          <iframe
            title="Al-Hameediya Restaurant location map"
            src={info?.map_embed || "https://maps.google.com/maps?q=21.107498,79.103401&z=16&output=embed"}
            className="absolute inset-0 w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}
